import { app } from '@/main.js';

const getDefaultState = () => {
  return {
    organisation:{},
    organisations:{},
    isBambooEnabled:{},
    isPolicyOwner: false,
 }
};

const state = getDefaultState();
const getters = {
  isPolicyOwner(state) {
    return state.isPolicyOwner;
  }
};

const actions = {
  resetState ({commit}) {
      commit('resetState')
  },

  async determinePolicyOwner({ commit, rootState }) {

    // If the organisation doesn't have the policy product, no need to check further.
    if (!rootState.auth.hasPolicy) {
      commit('setIsPolicyOwner', false);
      return;
    }

    if (rootState.auth.isSuperAdmin) {
      // No need to check for super admins, but let's ensure state is correct
      commit('setIsPolicyOwner', true);
      return;
    }

    const orgID = rootState.auth.isSuperAdmin || rootState.auth.accessType === 'vertex_analyst'
      ? rootState.user.organisation.id
      : rootState.user.organisation.organisation_id;
    const userID = rootState.auth.jwtPayload.user_id;

    if (!orgID || !userID) {
      commit('setIsPolicyOwner', false);
      return;
    }

    try {
      const response = await app.config.globalProperties.$axios.get(`/trainings/organisations/${orgID}/users/${userID}/training-policy/is-owner`);
      if (response.data.success) {
        commit('setIsPolicyOwner', response.data.is_policy_owner);
      } else {
        commit('setIsPolicyOwner', false);
      }
    } catch (error) {
      console.error("Error determining policy ownership:", error);
      commit('setIsPolicyOwner', false);
    }
  },
}

const mutations = {
  setOrganisation(state, data) {
      state.organisation = data
  },

  setOrganisations(state, data) {
      state.organisations = data
  },

  // setNavtips(state, data) {
  //     state.navtips = data
  // },

  resetState(state) {
    Object.assign(state, getDefaultState())
  },

  setBambooState(state, data) {
    state.isBambooEnabled = data
  },

  setIsPolicyOwner(state, value) {
    state.isPolicyOwner = value;
  },
};

export default {
  name: 'user',
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};